export default __webpack_public_path__ + "static/media/argon-dashboard-pro-react.8d6c2a9a.jpg";